export default __webpack_public_path__ + "static/media/R5C_8024.01352c08.jpg";